import { type ReactNode } from "react";
import useResizeObserver from "use-resize-observer";

import { cn } from "shared/lib";

import { useShouldRenderSideBySide } from "@/hooks";

import { Separator } from "shared/components";
import { ConversationProgressHeader } from "./ConversationProgressHeader";
import { LotPanel } from "./LotPanel";

export interface StepLayoutProps {
  children?: ReactNode;
  className?: string;
  leftPanelClassName?: string;
  disableSideBySide?: boolean;
}

export function StepLayout({
  children,
  className,
  leftPanelClassName,
  disableSideBySide,
}: StepLayoutProps) {
  const { ref: progressHeaderContainerRef, width = 1 } =
    useResizeObserver<HTMLDivElement>();

  const shouldRenderSideBySide = useShouldRenderSideBySide();

  return (
    <div className="flex flex-col md:m-10">
      <div className="flex justify-center pb-6">
        <div
          className="flex flex-col"
          style={{
            ...(width > 1
              ? { width: `${width}px`, maxWidth: `${width}px` }
              : {}),
          }}
        >
          <ConversationProgressHeader />
        </div>
      </div>

      <div className={cn("flex h-full justify-center", className)}>
        <div
          className={cn(
            "flex h-full w-full flex-col items-stretch gap-y-10 md:h-[calc(100%-theme(space.10))] md:w-[600px] md:max-w-[600px]",
            leftPanelClassName,
            shouldRenderSideBySide &&
              !disableSideBySide &&
              "not-rtl:mr-6 rtl:ml-6",
          )}
          ref={progressHeaderContainerRef}
        >
          {children}
        </div>

        {shouldRenderSideBySide && !disableSideBySide ? (
          <>
            <Separator className="h-auto" orientation="vertical" />

            <div className="flex w-[400px] max-w-[400px] flex-col p-6 pt-0">
              <LotPanel />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
